import { createSlice } from '@reduxjs/toolkit'
import Category from 'state/models/Category'
import { useObjSelectorOrFetch } from 'utils'
import API from './API'

const initialState = {
	list: [],
}

const slice = createSlice({
	name: 'categories',
	initialState,

	reducers: {
		load           : (state, { payload: categories }) => { Object.assign(state, { list: categories }) },
		clearCategories: state => initialState,

		updateCategory: (state, { payload: { id, ...fields } }) => {
			Object.assign(state.list.find(cat => cat.id == id), fields)
		},
	},
})

slice.thunks = {
	editCategory: (id, category) => async (dispatch, getState) => {
		const original = getState().categories.list.find(cat => cat.id == id)
		dispatch(slice.actions.updateCategory({ id, ...category }))
		API.patch(`category/${id}`, category)
			.catch(e => { //optimistic call, thus... let's revert on error
				console.error(e)
				dispatch(slice.actions.updateCategory({ id, original }))
			})
	},

	fetchCategories: async (dispatch) => {
		const resp = await API.get(`category`)
		dispatch(slice.actions.load(resp.data))
	},
}

export const getCategories = ({ categories }) => Category.map(categories.list)

/**
 * Selects the categories from the state with a hook.
 * If that's empty, tries to request them from the API.
 * @returns {Category[]}
 */
export const useCategories = () => useObjSelectorOrFetch(getCategories, fetchCategories, slice.name)

export const { clearCategories } = slice.actions

export const { editCategory, fetchCategories } = slice.thunks
export default slice.reducer
